import { IRenderer } from '../renderTree.types';

export const TextRenderer: IRenderer = ({ children }) => {
  return <>{children}</>;
};
